import React from "react";
import Phone from "../assets/icons/phone.png";
import Gmail from "../assets/icons/gmail.png";
import Clock from "../assets/icons/clock.png";

const TopNav = () => {
  const announcement = (
    <div className="flex items-center gap-8 px-8 text-sm">
      <span className="flex items-center gap-2">
        <img src={Phone} alt="Phone icon" className="w-4 h-4" /> 09165311972
      </span>

      <span className="flex items-center gap-2">
        <img src={Gmail} alt="Email icon" className="w-4 h-4" />{" "}
        clearicondiagnostics@gmail.com
      </span>

      <span className="flex items-center gap-2">
        <img src={Clock} alt="Clock icon" className="w-4 h-4" /> Mon - Sat: 8:00
        AM - 6:00 PM
      </span>
    </div>
  );

  return (
    <div className="w-full overflow-hidden py-1 bg-[#4A4C4C] text-white">
      {/* Scrolling container */}
      <div className="whitespace-nowrap flex animate-scroll">
        {announcement}
        {announcement}
      </div>
    </div>
  );
};

export default TopNav;
